<template>
    <component :is="component" v-if="component" :bannerData="bannerData" :uccStatus="uccStatus"/>
</template>

<script>
export default {
    name: "BannerListLink",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        listLayout: {},
        bannerData: {default: () => []},
    },
    data() {
        return {
            component: null,
        }
    },
    created() {
    },
    mounted() {
        this.listLoader();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/banner/list/${this.listLayout}`)
        },
    },
    methods: {
        listLoader() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/banner/list/BannerListDefaultLayout')
                })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
